import { useGetAllRevisionsQuery } from './api/query.get-all.js';

function useActiveRevision(courseId) {
  const revisions = useGetAllRevisionsQuery(courseId);
  return revisions.data?.find(it => it.isActive);
}

export { useActiveRevision };
//# sourceMappingURL=hook.active-revision.js.map
